import * as React from "react";
import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { ContextActions } from "../../../../../../../../react-core/Flux/ContextActions";
import { ContextStore } from "../../../../../../../../react-core/Flux/Variables";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { SelectEditor } from "../../../../../../../../react-core/Html/SelectEditor";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { ContextType } from "../../../../../../../../Wrap/Constants/Enums/ContextType";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { HierarchyLevelName } from "../../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { SubAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/SubAccount";
import { HierarchyIdHelper } from "../../../../../../../Shared/Common/HierarchyIdHelper";
import AdviserSiteTagManager from "../../../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { StaticUrls } from "../../../../../../Resoures/StaticUrls";
import { UserStore } from "../../../../../../Stroes/Variable";
import { Urls } from "../../../../../../Urls";
import { subAccountTypeMap } from "../../Performance/Resource/Contents";
import {
    PortfolioDashboardMultiSelectionDisaptcher,
    PortfolioDashboardMultiSelectionStore,
    PortfolioDashboardStore,
} from "../../../Store/Variable";
import {
    IPortfolioDashboardComponentProps,
    PortfolioDashboardComponent,
} from "../../Common/PortfolioDashboardComponent";
import { ChargesTable } from "./ChargesTable";
import { ProductOverviewPaymentsIn } from "./PaymentsIn/ProductOverviewPaymentsIn";
import { ProductOverviewProductInformation } from "./ProductOverviewProductInformation";
import { ProductOverviewWithdrawal } from "./ProductOverviewWithdrawal";
import { ProductOverviewCrystallisation } from "./ProductOverviewCrystallisation";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { ProductOverviewValuationAndIncome } from "./ProductOverviewValuationAndIncome";
import { ProductOverviewInvestmentPathways } from "./ProductOverviewInvestmentPathways";

interface IProductOverviewProps extends IPortfolioDashboardComponentProps { }

interface IProductOverviewState {
    content: JSX.Element;
    tabIndex: ProductOverViewTabContent;
    isLoading: boolean;
    selectedAccount: SubAccount;
    dropdownList: SubAccount[];
    headAccount: ClientAccount;
}

export enum ProductOverViewTabContent {
    ValuationAndIncome = "Valuation and income",
    PaymentsIn = "Payments in",
    Withdrawls = "Withdrawals",
    Crystallisation = "Drawdown",
    Charges = "Charges",
    ProductInformation = "Product information",
    InvestmentPathways = "Investment Pathways",
}

export class ProductOverview extends PortfolioDashboardComponent<IProductOverviewProps, IProductOverviewState> {
    constructor(props: any) {
        super(props);
        this.subscribeToStore(ContextStore, () => {
            if (
                ContextStore.getUrlParamsHierarchyId(ContextType.SubAccount) &&
                ContextStore.getUrlParamsHierarchyId(ContextType.SubAccount) !== this.state.selectedAccount?.HierarchyId
            ) {
                this.initUrlSubAccount(ContextStore.getUrlParamsHierarchyId(ContextType.SubAccount));
                this.getDropdownList(PortfolioDashboardMultiSelectionStore.getData());
            }
        });
    }

    initState() {
        this.state = {
            content: null,
            tabIndex: ProductOverViewTabContent.PaymentsIn,
            isLoading: true,
            selectedAccount: null,
            dropdownList: [],
            headAccount: null,
        };
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    componentDidMount(): void {
        const subAccountHierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.SubAccount);
        const curSelection = PortfolioDashboardMultiSelectionStore.getData();
        let newSelection = curSelection;
        if (!curSelection.includes(ContextStore.getUrlParamsHierarchyId(ContextType.SubAccount))) {
            const { headAccount } = this.getSubAccountDetail(subAccountHierarchyId);
            newSelection = curSelection.concat((headAccount?.SubAccounts || []).map((sub) => sub.HierarchyId));
            PortfolioDashboardMultiSelectionDisaptcher.dispatch({
                payload: newSelection,
                actionType: ActionType.Success,
            });
        }
        this.initUrlSubAccount(subAccountHierarchyId);
        this.getDropdownList(newSelection);
        this.addEvent({
            environment: {
                appType: "web",
                setting: "prod",
                timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
            },
            page: {
                pageUrl: Urls.get()
                    .main.PortfolioDashboard({
                        hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                            HierarchyLevelName.Customer,
                            this.props.customerid
                        ),
                    })
                    .productOverView({
                        subaccounthierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.SubAccount),
                    })
                    .productOverView.getUrl(),
                pageTitle: `${document.title} - client - transactions`,
            },
            user: {
                loginId: UserStore.getUserInfo()?.ClientId.toString(),
                internal: "yes",
            },
            event: "pageLoaded",
        });
    }

    initUrlSubAccount = (subAccountHierarchyId: string) => {
        if (subAccountHierarchyId !== this.state.selectedAccount?.HierarchyId) {
            this.setState({ isLoading: true });
            const { subAccount, headAccount } = this.getSubAccountDetail(subAccountHierarchyId);
            this.setState({ selectedAccount: subAccount, headAccount: headAccount }, () => {
                this.getContent(SubAccountTypeHelper.isOnPlatformPension(this.state.selectedAccount?.SubAccountType) ?  ProductOverViewTabContent.ValuationAndIncome : ProductOverViewTabContent.PaymentsIn);
            });
        }
    };

    private getSubAccountDetail = (subaccount: string) => {
        const allAccounts = PortfolioDashboardStore.getData();
        let selectedSubAccount: SubAccount = null;
        let headAccount: ClientAccount = null;
        allAccounts.forEach((account) => {
            (account.SubAccounts || []).forEach((sub) => {
                if (sub.HierarchyId === subaccount) {
                    selectedSubAccount = sub;
                    headAccount = account;
                }
            });
        });
        return { subAccount: selectedSubAccount, headAccount: headAccount };
    };

    getData(multiselection: string[]) {
        if (multiselection.includes(ContextStore.getUrlParamsHierarchyId(ContextType.SubAccount))) {
            this.getDropdownList(multiselection);
        } else {
            Navigator.navigateTo(
                Urls.get()
                    .main.PortfolioDashboard({
                        hierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                    })
                    .productOverView({ subaccounthierarchyId: multiselection[0] }).productOverView
            );
        }
    }

    private getDropdownList = (multiselection: string[]) => {
        if (!multiselection) {return [];}
        const list: SubAccount[] = [];
        const allAccounts = PortfolioDashboardStore.getData();

        (allAccounts || []).forEach((account) => {
            (account?.SubAccounts || []).forEach((sub) => {
                if (multiselection.includes(sub?.HierarchyId)) {
                    list.push(sub);
                }
            });
        });

        this.setState({ dropdownList: list, isLoading: false });
    };

    public getContent(key: ProductOverViewTabContent) {
        let _content = null;
        const { selectedAccount, headAccount } = this.state;
        switch (key) {
            case ProductOverViewTabContent.PaymentsIn:
                _content = (
                    <ProductOverviewPaymentsIn
                        subAccountHierarchyId={selectedAccount?.HierarchyId}
                        selectedProduct={selectedAccount?.SubAccountType}
                        headaccount={headAccount}
                    />
                );
                break;
            case ProductOverViewTabContent.ValuationAndIncome:
                _content = (
                    <ProductOverviewValuationAndIncome
                        subAccountHierarchyId={selectedAccount?.HierarchyId}
                        subClAccountId={selectedAccount?.ClAccountId}
                        selectedProduct={selectedAccount?.SubAccountType}
                        headaccount={headAccount}
                        customerid={this.props.customerid}
                    />
                );
                break;
            case ProductOverViewTabContent.InvestmentPathways:
                _content = (
                    <ProductOverviewInvestmentPathways
                        subAccountHierarchyId={selectedAccount?.HierarchyId}
                    />
                );
                break;
            case ProductOverViewTabContent.Withdrawls:
                _content = (
                    <ProductOverviewWithdrawal
                        subAccountHierarchyId={selectedAccount?.HierarchyId}
                        subClAccountId={selectedAccount?.ClAccountId}
                        selectedProduct={selectedAccount?.SubAccountType}
                        headaccount={headAccount}
                    />
                );
                break;
            case ProductOverViewTabContent.Charges:
                _content = (
                    <ChargesTable
                        subAccountHierarchyId={selectedAccount?.HierarchyId}
                        selectedProduct={selectedAccount?.SubAccountType}
                        subClAccountId={selectedAccount?.ClAccountId}
                        accountHierarchyId={this.state.headAccount.HierarchyId}
                    />
                );
                break;
            case ProductOverViewTabContent.ProductInformation:
                _content = (
                    <ProductOverviewProductInformation
                        subAccountHierarchyId={selectedAccount?.HierarchyId}
                        selectedProduct={selectedAccount?.SubAccountType}
                        headaccount={headAccount}
                    />
                );
                break;
            case ProductOverViewTabContent.Crystallisation:
                _content = (
                    <ProductOverviewCrystallisation
                        headaccount={headAccount}
                        customerHierarchyId={ContextStore.getUrlParamsHierarchyId(ContextType.Customer)}
                        subAccountHierarchyId={selectedAccount?.HierarchyId}
                        subClAccountId={selectedAccount?.ClAccountId}
                        subAccountType={selectedAccount?.SubAccountType}
                        accountHierarchyId={this.state.headAccount.HierarchyId}
                    />
                );
                break;
        }
        this.setState({ content: _content, tabIndex: key, isLoading: false });
    }

    public render(): JSX.Element {
        const { tabIndex, isLoading } = this.state;
        if (isLoading) {return <PartLoading isLoading={true} />;}

        const { selectedAccount } = this.state;

        const tabs = [];
        for (const key in ProductOverViewTabContent) {
            //do not display withdrawals if JSIPP
            if (selectedAccount &&
                (selectedAccount.SubAccountType === SubAccountType.JuniorSipp || selectedAccount.ProductDisplayName === "abrdn JSIPP" || selectedAccount.SubAccountType === SubAccountType.Npr || selectedAccount.ProductDisplayName === "abrdn SIPP") &&
                key === "Withdrawls") {
                continue;
            }

            if (
                (key === "Crystallisation" || key === "ValuationAndIncome" || key === "InvestmentPathways") &&
                (!SubAccountTypeHelper.isOnPlatformPension(selectedAccount?.SubAccountType))
            ) {
                //don't display the crystallisation and valuation and income tab for accounts that aren't pension
                continue;
            }

            tabs.push(
                <button
                    role="tab"
                    key={`tab-${key}`}
                    className="item"
                    aria-selected={tabIndex === ProductOverViewTabContent[key]}
                    onClick={() => this.getContent(ProductOverViewTabContent[key])}
                >
                    {ProductOverViewTabContent[key]}
                </button>
            );
        }

        return (
            <>
                <div className="ad d1">
                    <div className="mb-10">
                        <button
                            onClick={() => {
                                ContextActions.setContext(null, ContextType.SubAccount);
                                Navigator.navigateTo(
                                    Urls.get().main.PortfolioDashboard({
                                        hierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                                    }).summary
                                );
                            }}
                            className="hyperlink-previous"
                        >
                            <span className="icon" aria-hidden={true}></span>
                            <span className="text">Back to summary</span>
                        </button>
                    </div>
                    <div>
                        <SelectEditor
                            label="Product type"
                            cssWrapper="control-size-370 label-sr-only mb-30"
                            options={this.state.dropdownList.map((item) => item.HierarchyId)}
                            getText={(o) => {
                                const selected = this.state.dropdownList.find((ele) => ele.HierarchyId == o);
                                return `${subAccountTypeMap[selected?.SubAccountType]} - ${selected?.ClAccountId}`;
                            }}
                            onChange={(k) => {
                                const selected = this.state.dropdownList.find((ele) => ele.HierarchyId == k);
                                if (selected?.SubAccountType == SubAccountType.Sipp) {
                                    window.location.assign(StaticUrls.SippDetail(selected?.ClAccountId));
                                } else {
                                    Navigator.navigateTo(
                                        Urls.get()
                                            .main.PortfolioDashboard({
                                                hierarchyId: ContextStore.getUrlParamsHierarchyId(ContextType.Customer),
                                            })
                                            .productOverView({ subaccounthierarchyId: k }).productOverView
                                    );
                                }
                            }}
                            selected={this.state.selectedAccount?.HierarchyId}
                        />
                    </div>
                    <nav role="tablist" className="tabs mb-37">
                        {tabs}
                    </nav>
                    <div className="anim-navigation-wrapper">{this.state.content}</div>
                </div>
            </>
        );
    }
}
